// 是否为桌面版
export const isClient = () => window.ssclient && window.ssclient.versions;

export const clientTool = isClient() ? window.ssclient : {};

// 根据UA判断当前应用是否为桌面端版本
export const desktopMajorVersion = () => {
    const ua = window.navigator.userAgent.toLowerCase();

    if (isClient() && ua) {
        if (ua.indexOf('salesmartly-desktop/1') > -1) {
            // 1.x版本
            return 'v1';
        }
        if (ua.indexOf('salesmartly-desktop/2') > -1) {
            // 2.x版本
            return 'v2';
        }
    }

    return '';
};
